var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"js-header"},[_c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"logo-box"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logoUrl}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }